import type { CampaignDisplayStatus } from '../../types/campaigns.types';
import { cn } from '@/lib/utils';

type CampaignStatusBadgeProps = {
  status: CampaignDisplayStatus;
};

/**
 * Prototype STATE_TONE / STATE_LABEL (store-campaigns.js):
 * draft=neutral, scheduled=info, sending=progress, sent=success, failed=error, cancelled=neutral.
 */
const STATUS_PILL_CLASS: Record<CampaignDisplayStatus, string> = {
  Draft: 'bg-[#F4F5F6] text-[#27272C] [&_.dot]:bg-[#757575]',
  Scheduled: 'bg-[#E6F0F8] text-[#27272C] [&_.dot]:bg-[#0066B2]',
  Sending: 'bg-[#E6F0F8] text-[#27272C] [&_.dot]:animate-pulse [&_.dot]:bg-[#0066B2]',
  Sent: 'bg-[#E7F4EC] text-[#27272C] [&_.dot]:bg-[#1F8A46]',
  Failed: 'bg-[#FCE4EA] text-[#27272C] [&_.dot]:bg-[#D80032]',
  Cancelled: 'bg-[#F4F5F6] text-[#27272C] [&_.dot]:bg-[#757575]',
};

export const CampaignStatusBadge = ({ status }: CampaignStatusBadgeProps) => {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-[3px] text-xs font-medium',
        STATUS_PILL_CLASS[status]
      )}
    >
      <span className="dot size-1.5 shrink-0 rounded-full" aria-hidden />
      {status}
    </span>
  );
};
